<template>
  <div class="mc-widget-call__end-call">
    <b-button
      v-b-tooltip.hover
      class="btn btn-muted btn-outline-primary"
      :class="{ small: isCollapsed }"
      :title="isMuted ? $t('trackVideo.unmuteMe') : $t('trackVideo.muteMe')"
      @click="toggleMuted"
    >
      <i v-show="!isMuted" class="mc-fa icon-outline_mic"></i>
      <i v-show="isMuted" class="mc-fa icon-outline_mic-off"></i>
    </b-button>
    <b-button
      class="btn btn-end-call"
      :class="{ small: isCollapsed }"
      @click="$emit('clickEndCall')"
    >
      <i class="mc-fa icon-outline_phone-off"></i> {{ $t('trackVideo.endAll') }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'EndCall',
  computed: {
    isMuted() {
      return this.$store.state.voip.isMuted
    },
    isCollapsed() {
      return this.$store.state.voip.isCollapsed
    },
  },
  methods: {
    async toggleMuted() {
      this.$store.commit('voip/toggleMuted')

      await this.$nextTick()
      this.$emit('clickToggleMuted')
    },
  },
}
</script>
